import React, { useEffect } from 'react';
import { ExpediteDeliveryCard } from '@shopee/chatbot-ui';
import { OrderCardType } from '@shopee/chatbot-ui/lib/components/OrderList';
import { cdnFile } from '@/utils/cdnFile';
import { TRACKING_MSG_TYPE, TRACKING_OPERATION, TRACKING_PAGE, TRACKING_SECTION, TRACKING_TARGET } from '@/utils/constants';
import { DEFAULT_ORDER_TYPE_DECS } from './PropsProtocol/OrderList';
import { ChatbotUIBasicProps } from '@/types/common';
import { dispatchTrack } from '@/utils/tracking';

export type ExpediteDeliverySuccessCardProps = {
  keyMessage: string;
  title: string;
  additionalMessage: string;
  /** 订单卡片 */
  order: any;
  taskBotInfo?: any;
} & ChatbotUIBasicProps;

const ExpediteDeliverySuccessCard: React.FC<ExpediteDeliverySuccessCardProps> = (props) => {
  const { order } = props;
  console.log('props', props);


  const trackingParams = {
    page: TRACKING_PAGE.MAIN_PAGE,
    operation: TRACKING_OPERATION.IMPRESSION,
    target: TRACKING_TARGET.successCard,
    section: TRACKING_SECTION.successCard,
  };
  const trackingData = {
    chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
    chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
    if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    bot_id: props.taskBotInfo?.bot_id,
  };

  useEffect(() => {
    dispatchTrack({ ...trackingParams, data: trackingData });
  }, []);

  return (
    <div>
      <ExpediteDeliveryCard
        {...props}
        order={{
          orderId: order?.order_id,
          orderSn: order?.order_sn,
          orderCardType: OrderCardType.expeditedDelivery,
          image: cdnFile(order?.image),
          title: order?.title,
          orderStatusText: DEFAULT_ORDER_TYPE_DECS[order?.order_status],
          deliverer: order?.delivered_by,
        }}
      />
    </div>
  );
};

export default ExpediteDeliverySuccessCard;
